<div class="modal-header">
    <div class="row col-12">
        <div class="modal-title col-10">
            <h5>Google Cloud Translation</h5>
        </div>

        <div class="text-end col-2">
            <button type="button" class="btn" aria-label="Close" (click)="activeModal.dismiss()">
                <span aria-hidden="true"><i class="fa-solid fa-x"></i></span>
            </button>
        </div>
    </div>
</div>
<div class="modal-body">
    <div class="d-flex">
        <div class="mb-3 me-3 flex-grow-1">
            <label for="readonlyTextbox" class="form-label">Original</label>
            <textarea type="text" class="form-control" id="readonlyTextbox" readonly
                [(ngModel)]="originalText"></textarea>
        </div>
        <div class="mb-3 flex-grow-1">
            <label for="editableTextbox" class="form-label">Oversat</label>
            <textarea [attr.lang]="language" type="text" class="form-control" id="editableTextbox" [(ngModel)]="translatedText"></textarea>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
        (click)="activeModal.dismiss('Cross click')">Annuller</button>
    <button type="button" class="btn btn-primary" (click)="accept()">Accepter</button>
</div>